module.exports = __webpack_public_path__ + "static/e-banquet-illu-2-17fad155626d0bef5fd82c6bf315fa6c.png";